import React, { useState, useRef, useEffect, useCallback } from "react";
import { DatePicker, Space } from 'antd';
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { PieChart, Pie, Cell } from "recharts";
import submissionrateImages from "../../assests/images/submissionrate.png";
import requestrateImages from "../../assests/images/requestrate.png";
import acceptanceImages from "../../assests/images/acceptance.png";
import averageqcImages from "../../assests/images/averageQC.png";
import lrcreationImages from "../../assests/images/lrCreation.png";
import gateentryImages from "../../assests/images/gateentry.png";
import grntatImages from "../../assests/images/grnTAT.png";
import payementcycletimeImages from "../../assests/images/paymentcycle.png";
import rattingupImages from "../../assests/images/Rattingup (2).png";
import Pagination from "@mui/material/Pagination";
import PaginationItem from "@mui/material/PaginationItem";
import Stack from "@mui/material/Stack";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer,BarChart,Bar,Rectangle } from 'recharts';
import TableListingWithoutDnD from "../common/tableListingWithoutDnD";
import { purchaseOrderServices } from "../../services/purchaseOrderServices";
import { useNavigate } from "react-router-dom";
import { adminServices } from "../../services/adminServices";
import CustomSearchDropdown from "../common/customSearchDropdown";
import { rfqServices } from "../../services/rfqServices";
import _ from "lodash";
import AlertComponent from "../alert/alert";
import { Backdrop, CircularProgress } from "@mui/material";
import { isEmptyDash } from "../../constant";

const initialColumns = [
  { id: "index", label: "S.No.", isSort: false, sortLabel: "", isSearchInput: false, inputText: "", formate: "TEXT"},
  { id: "poNumber", label: "PO No.", isSort: false, sortLabel: "", isSearchInput: false, inputText: "", formate: "TEXT"},
  { id: "sapPoCode", label: "SAP PO Code", isSort: false, sortLabel: "", isSearchInput: false, inputText: "", formate: "TEXT" },
  { id: "vendorName", label: "Vendor Name", isSort: false, sortLabel: "", isSearchInput: false, inputText: "", formate: "TEXT" },
  { id: "companyCode", label: "Company Id", isSort: false, sortLabel: "", isSearchInput: false, inputText: "", formate: "TEXT" },
  { id: "buyerName", label: "Buyer Name", isSort: false, sortLabel: "", isSearchInput: false, inputText: "", formate: "TEXT" },
  { id: "orderDate", label: "Order Date", isSort: false, sortLabel: "", isSearchInput: false, inputText: "", formate: "DATE" },
  { id: "totalQuantity", label: "Total Qty", isSort: false, sortLabel: "", isSearchInput: false, inputText: "", formate: "TEXT" },
  { id: "netValue", label: "Net Value", isSort: false, sortLabel: "", isSearchInput: false, inputText: "", formate: "RATE" },
  { id: "status", label: "Status", isSort: false, sortLabel: "", isSearchInput: false, inputText: "", formate: "TEXT" },
  // { id: "error", label: "Error Msg (If failed)", isSort: false, sortLabel: "", isSearchInput: false, inputText: "", formate: "TEXT" },
  { id: "col10", label: "Actions", isSort: false, sortLabel: "", formate: "Redirect_Btn", redirectUrl:"/admin/po-detail-services", redirectKeyName: "_id" },
];

const kpiDataInit = [
  {
    percentage: "15",
    days:"%",
    kpiName: "PO Modification Request Rate",
    ratingImage: rattingupImages,
    ratingPercentage:"0%",
    month: "This Month",
    value: "",
    unit:"",
    key: "POModificationRequestRate",
    vendorImage:requestrateImages,
  },
  {
    percentage: "20",
    days:"%",
    kpiName: "PR Modification Request Rate",
    ratingImage: rattingupImages,
    ratingPercentage:"0%",
    month: "This Month",
    value: "",
    unit:"",
    key: "PRModificationRequestRate",
    vendorImage:submissionrateImages,
  },
  {
    percentage: "3",
    days:"Days",
    kpiName: "PO Averag Acceptance Time",
    ratingImage: rattingupImages,
    ratingPercentage:"0%",
    month: "This Month",
    value: "",
    unit:"",
    key: "averageAcceptanceTime",
    vendorImage:acceptanceImages,
  },
  {
    percentage: "2",
    days:"Days",
    kpiName: "Average QC TAT",
    ratingImage: rattingupImages,
    ratingPercentage:"0%",
    month: "This Month",
    value: "",
    unit:"",
    key: "averageQCTAT",
    vendorImage:averageqcImages,
  },
  {
    percentage: "1",
    days:"Days",
    kpiName: "Average LR Creation Time",
    ratingImage: rattingupImages,
    ratingPercentage:"0%",
    month: "This Month",
    value: "",
    unit:"",
    key: "averageLRCreationTime",
    vendorImage:lrcreationImages,
  },
  {
    percentage: "0.5",
    days:"Days",
    kpiName: "Average Gate Entry Time",
    ratingImage: rattingupImages,
    ratingPercentage:"0%",
    month: "This Month",
    value: "",
    unit:"",
    key: "averageGateEntryTime",
    vendorImage:gateentryImages,
  },
  {
    percentage: "1",
    days:"Days",
    kpiName: "Average GRN TAT",
    ratingImage: rattingupImages,
    ratingPercentage:"0%",
    month: "This Month",
    value: "",
    unit:"",
    key: "averageGRNTAT",
    vendorImage:grntatImages,
  },
  // {
  //   percentage: "1",
  //   days:"Days",
  //   kpiName: "PO to Payment Cycle Time",
  //   ratingImage: rattingupImages,
  //   ratingPercentage:"19%",
  //   month: "This Month",
  //   value: "",
  //   unit:"",
  //   key: "submissionRate",
  //   vendorImage:payementcycletimeImages,
  // },
  
]
const chartdataInit = [
  { name: 'Jan', TotalPOsReleased: 0, ModificationRequestRate : 0, TotalPOsWithModifications: 0 },
  { name: 'Feb', TotalPOsReleased: 0, ModificationRequestRate: 0, TotalPOsWithModifications: 0 },
  { name: 'Mar', TotalPOsReleased: 0, ModificationRequestRate: 0, TotalPOsWithModifications: 0 },
  { name: 'Apr', TotalPOsReleased: 0, ModificationRequestRate: 0, TotalPOsWithModifications: 0 },
  { name: 'May', TotalPOsReleased: 0, ModificationRequestRate: 0, TotalPOsWithModifications: 0 },
  { name: 'Jun', TotalPOsReleased: 0, ModificationRequestRate: 0, TotalPOsWithModifications: 0 },
  { name: 'Jul', TotalPOsReleased: 0, ModificationRequestRate: 0, TotalPOsWithModifications: 0 },
  { name: 'Aug', TotalPOsReleased: 0, ModificationRequestRate: 0, TotalPOsWithModifications: 0 },
  { name: 'Sep', TotalPOsReleased: 0, ModificationRequestRate: 0, TotalPOsWithModifications: 0 },
  { name: 'Oct', TotalPOsReleased: 0, ModificationRequestRate: 0, TotalPOsWithModifications: 0 },
  { name: 'Nov', TotalPOsReleased: 0, ModificationRequestRate: 0, TotalPOsWithModifications: 0 },
  { name: 'Dec', TotalPOsReleased: 0, ModificationRequestRate: 0, TotalPOsWithModifications: 0 },
];
const prModificationRateInit = [
  { name: 'Jan', TotalPRsCreated: 0, TotalPRsWithModifications: 0, MaxCycleTime: 0 },
  { name: 'Feb', TotalPRsCreated: 0, TotalPRsWithModifications: 0, MaxCycleTime: 0 },
  { name: 'Mar', TotalPRsCreated: 0, TotalPRsWithModifications: 0, MaxCycleTime: 0 },
  { name: 'Apr', TotalPRsCreated: 0, TotalPRsWithModifications: 0, MaxCycleTime: 0 },
  { name: 'May', TotalPRsCreated: 0, TotalPRsWithModifications: 0, MaxCycleTime: 0 },
  { name: 'Jun', TotalPRsCreated: 0, TotalPRsWithModifications: 0, MaxCycleTime: 0 },
  { name: 'Jul', TotalPRsCreated: 0, TotalPRsWithModifications: 0, MaxCycleTime: 0 },
  { name: 'Aug', TotalPRsCreated: 0, TotalPRsWithModifications: 0, MaxCycleTime: 0 },
  { name: 'Sep', TotalPRsCreated: 0, TotalPRsWithModifications: 0, MaxCycleTime: 0 },
  { name: 'Oct', TotalPRsCreated: 0, TotalPRsWithModifications: 0, MaxCycleTime: 0 },
  { name: 'Nov', TotalPRsCreated: 0, TotalPRsWithModifications: 0, MaxCycleTime: 0 },
  { name: 'Dec', TotalPRsCreated: 0, TotalPRsWithModifications: 0, MaxCycleTime: 0 },
];
const poAcceptanceataInit = [
  { name: 'Jan', MinAcceptanceTime: 0, AverageAcceptanceTime: 0, MaxAcceptanceTime: 0 },
  { name: 'Feb', MinAcceptanceTime: 0, AverageAcceptanceTime: 0, MaxAcceptanceTime: 0 },
  { name: 'Mar', MinAcceptanceTime: 0, AverageAcceptanceTime: 0, MaxAcceptanceTime: 0 },
  { name: 'Apr', MinAcceptanceTime: 0, AverageAcceptanceTime: 0, MaxAcceptanceTime: 0 },
  { name: 'May', MinAcceptanceTime: 0, AverageAcceptanceTime: 0, MaxAcceptanceTime: 0 },
  { name: 'Jun', MinAcceptanceTime: 0, AverageAcceptanceTime: 0, MaxAcceptanceTime: 0 },
  { name: 'Jul', MinAcceptanceTime: 0, AverageAcceptanceTime: 0, MaxAcceptanceTime: 0 },
  { name: 'Aug', MinAcceptanceTime: 0, AverageAcceptanceTime: 0, MaxAcceptanceTime: 0 },
  { name: 'Sep', MinAcceptanceTime: 0, AverageAcceptanceTime: 0, MaxAcceptanceTime: 0 },
  { name: 'Oct', MinAcceptanceTime: 0, AverageAcceptanceTime: 0, MaxAcceptanceTime: 0 },
  { name: 'Nov', MinAcceptanceTime: 0, AverageAcceptanceTime: 0, MaxAcceptanceTime: 0 },
  { name: 'Dec', MinAcceptanceTime: 0, AverageAcceptanceTime: 0, MaxAcceptanceTime: 0 },
];
const qcTimedataInit = [
  { name: 'Jan', MinQCTAT: 0, AverageQCTAT: 0, MaxQCTAT: 0 },
  { name: 'Feb', MinQCTAT: 0, AverageQCTAT: 0, MaxQCTAT: 0 },
  { name: 'Mar', MinQCTAT: 0, AverageQCTAT: 0, MaxQCTAT: 0 },
  { name: 'Apr', MinQCTAT: 0, AverageQCTAT: 0, MaxQCTAT: 0 },
  { name: 'May', MinQCTAT: 0, AverageQCTAT: 0, MaxQCTAT: 0 },
  { name: 'Jun', MinQCTAT: 0, AverageQCTAT: 0, MaxQCTAT: 0 },
  { name: 'Jul', MinQCTAT: 0, AverageQCTAT: 0, MaxQCTAT: 0 },
  { name: 'Aug', MinQCTAT: 0, AverageQCTAT: 0, MaxQCTAT: 0 },
  { name: 'Sep', MinQCTAT: 0, AverageQCTAT: 0, MaxQCTAT: 0 },
  { name: 'Oct', MinQCTAT: 0, AverageQCTAT: 0, MaxQCTAT: 0 },
  { name: 'Nov', MinQCTAT: 0, AverageQCTAT: 0, MaxQCTAT: 0 },
  { name: 'Dec', MinQCTAT: 0, AverageQCTAT: 0, MaxQCTAT: 0 },
];
const lrcreationdataInit = [
  { name: 'Jan', AverageLRCreationTime: 0, MaxLRCreationTime: 0, MinLRCreationTime: 0 },
  { name: 'Feb', AverageLRCreationTime: 0, MaxLRCreationTime: 0, MinLRCreationTime: 0 },
  { name: 'Mar', AverageLRCreationTime: 0, MaxLRCreationTime: 0, MinLRCreationTime: 0 },
  { name: 'Apr', AverageLRCreationTime: 0, MaxLRCreationTime: 0, MinLRCreationTime: 0 },
  { name: 'May', AverageLRCreationTime: 0, MaxLRCreationTime: 0, MinLRCreationTime: 0 },
  { name: 'Jun', AverageLRCreationTime: 0, MaxLRCreationTime: 0, MinLRCreationTime: 0 },
  { name: 'Jul', AverageLRCreationTime: 0, MaxLRCreationTime: 0, MinLRCreationTime: 0 },
  { name: 'Aug', AverageLRCreationTime: 0, MaxLRCreationTime: 0, MinLRCreationTime: 0 },
  { name: 'Sep', AverageLRCreationTime: 0, MaxLRCreationTime: 0, MinLRCreationTime: 0 },
  { name: 'Oct', AverageLRCreationTime: 0, MaxLRCreationTime: 0, MinLRCreationTime: 0 },
  { name: 'Nov', AverageLRCreationTime: 0, MaxLRCreationTime: 0, MinLRCreationTime: 0 },
  { name: 'Dec', AverageLRCreationTime: 0, MaxLRCreationTime: 0, MinLRCreationTime: 0 },
];
const gateentrydataInit = [
  { name: 'Jan', AverageGateEntryTime: 0, MinGateEntryTime: 0, MaxGateEntryTime: 0 },
  { name: 'Feb', AverageGateEntryTime: 0, MinGateEntryTime: 0, MaxGateEntryTime: 0 },
  { name: 'Mar', AverageGateEntryTime: 0, MinGateEntryTime: 0, MaxGateEntryTime: 0 },
  { name: 'Apr', AverageGateEntryTime: 0, MinGateEntryTime: 0, MaxGateEntryTime: 0 },
  { name: 'May', AverageGateEntryTime: 0, MinGateEntryTime: 0, MaxGateEntryTime: 0 },
  { name: 'Jun', AverageGateEntryTime: 0, MinGateEntryTime: 0, MaxGateEntryTime: 0 },
  { name: 'Jul', AverageGateEntryTime: 0, MinGateEntryTime: 0, MaxGateEntryTime: 0 },
  { name: 'Aug', AverageGateEntryTime: 0, MinGateEntryTime: 0, MaxGateEntryTime: 0 },
  { name: 'Sep', AverageGateEntryTime: 0, MinGateEntryTime: 0, MaxGateEntryTime: 0 },
  { name: 'Oct', AverageGateEntryTime: 0, MinGateEntryTime: 0, MaxGateEntryTime: 0 },
  { name: 'Nov', AverageGateEntryTime: 0, MinGateEntryTime: 0, MaxGateEntryTime: 0 },
  { name: 'Dec', AverageGateEntryTime: 0, MinGateEntryTime: 0, MaxGateEntryTime: 0 },
];
const goodreceiptsdataInit = [
  { name: 'Jan', AverageGRNTAT: 0, MinGRNTAT: 0, MaxGRNTAT: 0 },
  { name: 'Feb', AverageGRNTAT: 0, MinGRNTAT: 0, MaxGRNTAT: 0 },
  { name: 'Mar', AverageGRNTAT: 0, MinGRNTAT: 0, MaxGRNTAT: 0 },
  { name: 'Apr', AverageGRNTAT: 0, MinGRNTAT: 0, MaxGRNTAT: 0 },
  { name: 'May', AverageGRNTAT: 0, MinGRNTAT: 0, MaxGRNTAT: 0 },
  { name: 'Jun', AverageGRNTAT: 0, MinGRNTAT: 0, MaxGRNTAT: 0 },
  { name: 'Jul', AverageGRNTAT: 0, MinGRNTAT: 0, MaxGRNTAT: 0 },
  { name: 'Aug', AverageGRNTAT: 0, MinGRNTAT: 0, MaxGRNTAT: 0 },
  { name: 'Sep', AverageGRNTAT: 0, MinGRNTAT: 0, MaxGRNTAT: 0 },
  { name: 'Oct', AverageGRNTAT: 0, MinGRNTAT: 0, MaxGRNTAT: 0 },
  { name: 'Nov', AverageGRNTAT: 0, MinGRNTAT: 0, MaxGRNTAT: 0 },
  { name: 'Dec', AverageGRNTAT: 0, MinGRNTAT: 0, MaxGRNTAT: 0 },
];

function TransactionalP2PDashboardTab(props) {
  
  let navigate = useNavigate();
  const navigateUrl = (param) => {
    navigate(param);
  };

  const [selectedObj, setSelectedObj] = useState(null);
  const [selectedVendorObj, setSelectedVendorObj] = useState(null);
  const [selectedObjPO, setSelectedObjPO] = useState(null);
  const [newDateRange, setNewDateRange] = useState({ from: "", to: "" });
  const [kpiData, setKPIData] = useState(kpiDataInit);
  
  const [chartdata1, setChartData1] = useState(chartdataInit);
  const [prModificationRate, setPRModificationRate] = useState(prModificationRateInit);
  const [poAcceptanceata, setPOAcceptanceata] = useState(poAcceptanceataInit);
  const [qcTimedata, setQCTimedata] = useState(qcTimedataInit);
  const [lrcreationdata, setLrcreationdata] = useState(lrcreationdataInit);
  const [gateentrydata, setGateentrydata] = useState(gateentrydataInit);
  const [goodreceiptsdata, setGoodreceiptsdata] = useState(goodreceiptsdataInit);
  
  const [alertComponent, setAlertComponent] = useState({
    open: false,
    message: "",
    type: "",
  });

  const handleCloseAlert = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setAlertComponent({ ...alertComponent, open: false });
  };

  const [isLoading, setIsLoading] = useState(false);

  const disabledDate = (current) => {
    return current && current < new Date().setHours(0, 0, 0, 0);
};

const onSearchSelectChange = (param, objData) => {
  // console.log(param);      
  setSelectedObj(param);
  setSelectedVendorObj(objData);
  setSelectedObjPO({selectedLable: "", selectedValue: ""}); 
}
const getUnit = (data) => {
  if (data.unit == "percentage") {
    return "%";
  }
  return data.unit;
} 

useEffect(() => {
  getDashboardOBData("", "");   
}, []);

  useEffect(() => {
    if (props?.count > 0) {
      // console.log("sdfsdf", props?.count); 
      let str1 = isEmptyDash(selectedObj?.selectedValue) ? "" : selectedObj?.selectedValue;
      let str2 = isEmptyDash(selectedObjPO?.selectedValue) ? "" : selectedObjPO?.selectedValue;
      getDashboardOBData(str1, str2);
    }     
  }, [props?.count]);

const getDashboardOBData = (vendorId, poId) => {
  let newDate = new Date();
  let newYear = newDate.getFullYear();
  newDateRange["from"] = `${newYear}-01-01`;
  newDateRange["to"] = `${newYear}-12-31`;
      
  let bodyData = {
    "poId": poId,
    "vendorId": vendorId,
    "dateRange": {
        "startDate": newDateRange?.from,
        "endDate": newDateRange?.to,
    }
  }; 
  console.log(bodyData); 
  
  setIsLoading(true);
  let promise = adminServices.adminDashboardP2P(bodyData);
  promise.then((res) => {
    if (res.data.success === true) {
      let data = res?.data?.data;
      // let data = dbResObj?.data;
        props?.addNewTime(new Date());

      let chartdataInit1 = _.cloneDeep(chartdataInit);
      let prModificationRateInit1 = _.cloneDeep(prModificationRateInit);
      let poAcceptanceataInit1 = _.cloneDeep(poAcceptanceataInit);
      let qcTimedataInit1 = _.cloneDeep(qcTimedataInit);
      let lrcreationdataInit1 = _.cloneDeep(lrcreationdataInit);
      let gateentrydataInit1 = _.cloneDeep(gateentrydataInit);
      let goodreceiptsdataInit1 = _.cloneDeep(goodreceiptsdataInit);
        
      let kpiData1 = _.cloneDeep(kpiData);
      for (let i = 0; i < kpiData1.length; i++) {          
        if (kpiData1[i]?.key == "POModificationRequestRate" ) {
          kpiData1[i].value = data["POModificationRequestRate"]["modificationRequestRate"];
          kpiData1[i].unit = getUnit(data["POModificationRequestRate"]);
        }          
        if (kpiData1[i]?.key == "PRModificationRequestRate" ) {
          kpiData1[i].value = data["PRModificationRequestRate"]["modificationRequestRate"];
          kpiData1[i].unit = getUnit(data["PRModificationRequestRate"]);
        }          
        if (kpiData1[i]?.key == "averageAcceptanceTime" ) {
          kpiData1[i].value = data["poAcceptanceTime"]["averageAcceptanceTime"];
          kpiData1[i].unit = getUnit(data["poAcceptanceTime"]);
        }          
        if (kpiData1[i]?.key == "averageQCTAT" ) {
          kpiData1[i].value = data["QCTAT"]["averageQCTAT"];
          kpiData1[i].unit = getUnit(data["QCTAT"]);
        }         
        if (kpiData1[i]?.key == "averageLRCreationTime" ) {
          kpiData1[i].value = data["avgLRCreationTime"]["averageLRCreationTime"];
          kpiData1[i].unit = getUnit(data["avgLRCreationTime"]);
        }         
        if (kpiData1[i]?.key == "averageGateEntryTime" ) {
          kpiData1[i].value = data["gateEntryTime"]["averageGateEntryTime"];
          kpiData1[i].unit = getUnit(data["gateEntryTime"]);
        }         
        if (kpiData1[i]?.key == "averageGRNTAT" ) {
          kpiData1[i].value = data["grnTAT"]["averageGRNTAT"];
          kpiData1[i].unit = getUnit(data["grnTAT"]);
        }
      }

      // For PO Modification Request Rate
      for (let j = 0; j < chartdataInit1.length; j++) {
        chartdataInit1[j]["amt"] = 0;
        chartdataInit1[j]["pv"] = 0;
        chartdataInit1[j]["uv"] = 0;
        for (let k = 0; k < data?.POModificationRequestRate?.monthlyData.length; k++) {
          if (j == data?.POModificationRequestRate?.monthlyData[k]?.month - 1) {
            chartdataInit1[j]["amt"] = data?.POModificationRequestRate?.monthlyData[k]?.modificationRequestRate ;
            chartdataInit1[j]["pv"] = data?.POModificationRequestRate?.monthlyData[k]?.totalPOsReleased;
            chartdataInit1[j]["uv"] = data?.POModificationRequestRate?.monthlyData[k]?.totalPOsWithModifications;              
          }
        }
      }

      // For PR Modification Rate
      for (let j = 0; j < prModificationRateInit1.length; j++) {
        prModificationRateInit1[j]["MaxCycleTime"] = 0;
        prModificationRateInit1[j]["TotalPRsCreated"] = 0;
        prModificationRateInit1[j]["TotalPRsWithModifications"] = 0;
        for (let k = 0; k < data?.PRModificationRequestRate?.monthlyData.length; k++) {
          if (j == data?.PRModificationRequestRate?.monthlyData[k]?.month - 1) {
            prModificationRateInit1[j]["MaxCycleTime"] = data?.PRModificationRequestRate?.monthlyData[k]?.modificationRequestRate;
            prModificationRateInit1[j]["TotalPRsCreated"] = data?.PRModificationRequestRate?.monthlyData[k]?.totalPRsCreated;
            prModificationRateInit1[j]["TotalPRsWithModifications"] = data?.PRModificationRequestRate?.monthlyData[k]?.totalPRsWithModifications;              
          }
        }
      }

      // For PO Acceptance
      for (let j = 0; j < poAcceptanceataInit1.length; j++) {
        poAcceptanceataInit1[j]["AverageAcceptanceTime"] = 0;
        poAcceptanceataInit1[j]["MaxAcceptanceTime"] = 0;
        poAcceptanceataInit1[j]["MinAcceptanceTime"] = 0;
        for (let k = 0; k < data?.poAcceptanceTime?.monthlyData.length; k++) {
          if (j == data?.poAcceptanceTime?.monthlyData[k]?.month - 1) {
            poAcceptanceataInit1[j]["AverageAcceptanceTime"] = data?.poAcceptanceTime?.monthlyData[k]?.averageAcceptanceTime;
            poAcceptanceataInit1[j]["MaxAcceptanceTime"] = data?.poAcceptanceTime?.monthlyData[k]?.maxAcceptanceTime;
            poAcceptanceataInit1[j]["MinAcceptanceTime"] = data?.poAcceptanceTime?.monthlyData[k]?.minAcceptanceTime;              
          }
        }
      }

      // For QC Check
      for (let j = 0; j < qcTimedataInit1.length; j++) {
        qcTimedataInit1[j]["AverageQCTAT"] = 0;
        qcTimedataInit1[j]["MaxQCTAT"] = 0;
        qcTimedataInit1[j]["MinQCTAT"] = 0;
        for (let k = 0; k < data?.QCTAT?.monthlyData.length; k++) {
          if (j == data?.QCTAT?.monthlyData[k]?.month - 1) {
            qcTimedataInit1[j]["AverageQCTAT"] = data?.QCTAT?.monthlyData[k]?.averageQCTAT;
            qcTimedataInit1[j]["MaxQCTAT"] = data?.QCTAT?.monthlyData[k]?.maxQCTAT;
            qcTimedataInit1[j]["MinQCTAT"] = data?.QCTAT?.monthlyData[k]?.minQCTAT;              
          }
        }
      }

      // For LR creation time
      for (let j = 0; j < lrcreationdataInit1.length; j++) {
        lrcreationdataInit1[j]["AverageLRCreationTime"] = 0;
        lrcreationdataInit1[j]["MaxLRCreationTime"] = 0;
        lrcreationdataInit1[j]["MinLRCreationTime"] = 0;

        for (let k = 0; k < data?.avgLRCreationTime?.monthlyData.length; k++) {
          if (j == data?.avgLRCreationTime?.monthlyData[k]?.month - 1) {
            lrcreationdataInit1[j]["AverageLRCreationTime"] = data?.avgLRCreationTime?.monthlyData[k]?.averageLRCreationTime;
            lrcreationdataInit1[j]["MaxLRCreationTime"] = data?.avgLRCreationTime?.monthlyData[k]?.maxLRCreationTime;
            lrcreationdataInit1[j]["MinLRCreationTime"] = data?.avgLRCreationTime?.monthlyData[k]?.minLRCreationTime;              
          }
        }          
      }
      

      // For Gate entry
      for (let j = 0; j < gateentrydataInit1.length; j++) {
        gateentrydataInit1[j]["AverageGateEntryTime"] = 0;
        gateentrydataInit1[j]["MaxGateEntryTime"] = 0;
        gateentrydataInit1[j]["MinGateEntryTime"] = 0;

        for (let k = 0; k < data?.gateEntryTime?.monthlyData.length; k++) {
          if (j == data?.gateEntryTime?.monthlyData[k]?.month - 1) {
            gateentrydataInit1[j]["AverageGateEntryTime"] = data?.gateEntryTime?.monthlyData[k]?.averageGateEntryTime;
            gateentrydataInit1[j]["MaxGateEntryTime"] = data?.gateEntryTime?.monthlyData[k]?.maxGateEntryTime;
            gateentrydataInit1[j]["MinGateEntryTime"] = data?.gateEntryTime?.monthlyData[k]?.minGateEntryTime;              
          }
        }          
      }
      

      // For Goods Reciept
      for (let j = 0; j < goodreceiptsdataInit1.length; j++) {
        goodreceiptsdataInit1[j]["AverageGRNTAT"] = 0;
        goodreceiptsdataInit1[j]["MaxGRNTAT"] = 0;
        goodreceiptsdataInit1[j]["MinGRNTAT"] = 0;

        for (let k = 0; k < data?.grnTAT?.monthlyData.length; k++) {
          if (j == data?.grnTAT?.monthlyData[k]?.month - 1) {
            goodreceiptsdataInit1[j]["AverageGRNTAT"] = data?.grnTAT?.monthlyData[k]?.averageGRNTAT;
            goodreceiptsdataInit1[j]["MaxGRNTAT"] = data?.grnTAT?.monthlyData[k]?.maxGRNTAT;
            goodreceiptsdataInit1[j]["MinGRNTAT"] = data?.grnTAT?.monthlyData[k]?.minGRNTAT;              
          }
        }          
      }

      // // console.log(data, vendordropoffdataInit1);
      
      setChartData1(chartdataInit1);
      setPRModificationRate(prModificationRateInit1);
      setPOAcceptanceata(poAcceptanceataInit1);
      setQCTimedata(qcTimedataInit1);
      setLrcreationdata(lrcreationdataInit1);
      setGateentrydata(gateentrydataInit1);
      setGoodreceiptsdata(goodreceiptsdataInit1);

      setKPIData(kpiData1);
    } else {
      setAlertComponent({ open: true, type: "error", message: `No Data Found ` });
    }
  })
  .catch(function (error) {
    console.log(error);
    setAlertComponent({ open: true, type: "error", message: `${error?.response?.data?.message}` });
  })
  .finally((param) => {
    setIsLoading(false);
  });
};

const clearData = (param) => {
  setSelectedObj({selectedLable: "", selectedValue: ""}); 
  setSelectedObjPO({selectedLable: "", selectedValue: ""}); 
  getDashboardOBData("", "");   
}
   
const onSearchSelectChangePO = (param) => {
  // console.log(param);      
  setSelectedObjPO(param);
}

  return (
    <div class="login-forms">
      <div class="text-centers">
      <div className="main_row_bidding_vendordonbdasboard">
            <div>
              <div className="required_react_vendor_block_dashboard">
              <label className="row_div_box_select_dashboard">Vendor ID</label>
              <div className="dashboard_site_select">
                  <CustomSearchDropdown 
                        // column={initialColumns}
                        listingArrName="vendors"
                        onSearchSelectChange={onSearchSelectChange}
                        promiseRequest={rfqServices.getExistingVendorRfqListing}
                        extraPromiseParam="poExists=true"
                        additionalData={{
                          lableKeyName1: "vendorName",
                          lableKeyName2: "",
                          valueKeyName: "_id",
                        }} 
                        // isDisable={(details?.assigneeId != UserObj?._id)}  
                        defaultValue={selectedObj}           
                    />  
                </div>
              </div>
            </div>

            <div>
              <div className="required_react_vendor_block_dashboard">
              <label className="row_div_box_select_dashboard">PO ID</label>
              <div className="dashboard_site_select">
                
                  <CustomSearchDropdown 
                        // column={initialColumns}
                        listingArrName="purchaseOrders"
                        onSearchSelectChange={onSearchSelectChangePO}
                        promiseRequest={purchaseOrderServices.getPurchaseOrderListing}
                        extraPromiseParam=""
                        isDependency={true}
                        dependencyData={{
                          method: "GET",
                          keyName: "vendorCode",
                          keyValue: selectedVendorObj?.portalVendorCode
                        }}
                        additionalData={{
                          lableKeyName1: "poNumber",
                          lableKeyName2: "",
                          valueKeyName: "_id",
                        }} 
                        // isDisable={(details?.assigneeId != UserObj?._id)}  
                        defaultValue={selectedObjPO}           
                    />  
                </div>
              </div>
            </div>
            <div>

            {/* <div className="required_react_vendor_block_dashboard">
              <div className="datepicker_vendor_dashoard">
                <label className="row_div_box_select_dashboard">Start Date </label>
                <label className="row_div_box_select_dashboard">End Date</label>
                </div>
                <div class="lets_modal_vendor">
                  <div class="col-sm-7">
                  <Space direction="vertical" size={20}>
                  <DatePicker.RangePicker  className="datepicker_widthdashboard"/>
                  </Space>
                  <div
                  class="error-message"
                  id="currentContactNameError"></div>
                  </div>
              </div>
            </div> */}

            </div>
            <div className="invoicing_dashboard_btns">
              <button type="button" class="btn btn-success save_next_btns" onClick={() => getDashboardOBData(selectedObj?.selectedValue, selectedObjPO?.selectedValue)}>
                Apply
              </button>
              <button type="button" class="btn clear_btn_status_block_lists" style={{marginLeft: "10px"}} onClick={clearData}>
                Clear
              </button>
            </div>

          </div>
          <div className="vendor_dasboard_maine_box_row">
           {
  kpiData.map((kpi,i) => (
    <div key={i} className="bpdt_row1_box11">
      <div className="bpdt_row1_box1_left">
        <div>
          <div className="pad_marg_row">
          <h1 className="noPadMarg percentage_vendor_dashboard_body">{kpi.value}</h1>
          <span className="days_percentage_name">{kpi.unit}</span>
          </div>
          <p className="noPadMarg Participated_bpdt_div">
            {kpi.kpiName}
          </p>
        </div>
        <div className="bpdt_row1_box1_left_row2">
          <div className="bpdt_row1_block">
            <img src={kpi.ratingImage} alt="" />
            <p className="rating_color">{kpi.ratingPercentage}</p>
            <p className="rating_color_down">{kpi.ratingPercentageone}</p>
            <p>{kpi.month}</p>
          </div>
        </div>
      </div>
      <div className="avergecyle_imges_body">
        <MoreVertIcon />
        <img src={kpi.vendorImage} alt="" className="avergecyle_imges" />
      </div>
    </div>
  ))
}
  </div>
  <div className="vendor_dashboard_onboarding_graph_row">
<div className="vendor_cycle_time_dashboard_body_row">
  <div className="row_odsboard_body">
  <p className="time_onboarding_body">PO Modification Request Rate</p>
  <MoreVertIcon />
  </div>
   <ResponsiveContainer width="100%" height={320}>
      <BarChart className="ResponsiveContainer_vendor_dashboard"
        data={chartdata1}
      >
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="name"  />
        <YAxis />
        <Tooltip  />
        <Legend  />
        <Bar className="responsive_vendor_dashboard" dataKey="ModificationRequestRate" fill="#9BBB58" shape={<Rectangle fill="#9BBB58" />} />
        <Bar className="responsive_vendor_dashboard" dataKey="TotalPOsReleased" fill="#9BBB58" shape={<Rectangle fill="#9BBB58" />} />
        <Bar className="responsive_vendor_dashboard" dataKey="TotalPOsWithModifications" fill="#9BBB58" shape={<Rectangle fill="#9BBB58" />} />
      </BarChart>
    </ResponsiveContainer>
</div>
<div className="vendor_cycle_time_dashboard_body_row">
  <div className="row_odsboard_body">
  <p className="time_onboarding_body">PR Modification Request Rate</p>
  <MoreVertIcon />
  </div>
    <ResponsiveContainer width="110%" height={300}>
      <LineChart className="ResponsiveContainer_vendor_dashboard" 
        data={prModificationRate}
      >
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="name" />
        <YAxis yAxisId="left" />
        <YAxis yAxisId="right" orientation="right" />
        <Tooltip />
        <Legend />
        <Line yAxisId="left" type="monotone" dataKey="TotalPRsCreated" stroke="#59E6F6" activeDot={{ r: 8 }} strokeWidth={3} dot={false}  />
        <Line yAxisId="left" type="monotone" dataKey="TotalPRsWithModifications" stroke="#7661E2" activeDot={{ r: 8 }} strokeWidth={3} dot={false}  />
      </LineChart>
    </ResponsiveContainer>
</div>
  </div>
  <div className="vendor_dashboard_secondbody_row">
  <div className="vendor_cycle_time_dashboard_body_row">
  <div className="row_odsboard_body">
  <p className="time_onboarding_body">PO Acceptance Time by Vendor</p>
  <MoreVertIcon />
  </div>
  <ResponsiveContainer width="100%" height={300}>
    <BarChart className="dashboard_barchart" data={poAcceptanceata}>
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="name" />
        <YAxis />
        <Tooltip />
        <Legend />
        <Bar dataKey="AverageAcceptanceTime" stackId="a" fill="#695EEF" />
        <Bar dataKey="MaxAcceptanceTime" stackId="a" fill="#11D1B7" />
        <Bar dataKey="MinAcceptanceTime" stackId="a" fill="#FFC061" />
    </BarChart>
</ResponsiveContainer>
</div>
<div className="vendor_cycle_time_dashboard_body_row">
  <div className="row_odsboard_body">
  <p className="time_onboarding_body">Quality Check Turnaround Time</p>
  <MoreVertIcon />
  </div>
  <ResponsiveContainer width="100%" height={300}>
    <BarChart className="dashboard_barchart" data={qcTimedata}>
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="name" />
        <YAxis />
        <Tooltip />
        <Legend />
        <Bar dataKey="AverageQCTAT" stackId="a" fill="#F6866A" />
        <Bar dataKey="MaxQCTAT" stackId="a" fill="#FABE7A" />
        <Bar dataKey="MinQCTAT" stackId="a" fill="#7661E2" />
    </BarChart>
</ResponsiveContainer>
</div>
<div className="vendor_cycle_time_dashboard_body_row">
  <div className="row_odsboard_body">
  <p className="time_onboarding_body">LR Creation Time from QC Date</p>
  <MoreVertIcon />
  </div>
  <ResponsiveContainer width="110%" height={300}>
      <LineChart className="ResponsiveContainer_vendor_dashboard" 
        data={lrcreationdata}
      >
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="name" />
        <YAxis yAxisId="left" />
        <YAxis yAxisId="right" orientation="right" />
        <Tooltip />
        <Legend />
        <Line yAxisId="left" type="monotone" dataKey="AverageLRCreationTime" stroke="#3CD856" activeDot={{ r: 8 }} strokeWidth={3} dot={false}  />
        <Line yAxisId="left" type="monotone" dataKey="MaxLRCreationTime" stroke="#FEC321" activeDot={{ r: 8 }} strokeWidth={3} dot={false}  />
        <Line yAxisId="left" type="monotone" dataKey="MinLRCreationTime" stroke="#59E6F6" activeDot={{ r: 8 }} strokeWidth={3} dot={false}  />
      </LineChart>
    </ResponsiveContainer>
</div>
  </div>
  <div className="vendor_dashboard_onboarding_graph_row">
<div className="vendor_cycle_time_dashboard_body_row">
  <div className="row_odsboard_body">
  <p className="time_onboarding_body">Gate Entry Time from LR Creation Date</p>
  <MoreVertIcon />
  </div>
  <ResponsiveContainer width="110%" height={300}>
      <LineChart className="ResponsiveContainer_vendor_dashboard" 
        data={gateentrydata}
      >
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="name" />
        <YAxis yAxisId="left" />
        <YAxis yAxisId="right" orientation="right" />
        <Tooltip />
        <Legend />
        <Line yAxisId="left" type="monotone" dataKey="MaxGateEntryTime" stroke="#7987FF" activeDot={{ r: 8 }} strokeWidth={3} dot={false}  />
        <Line yAxisId="left" type="monotone" dataKey="AverageGateEntryTime" stroke="#FFA5CB" activeDot={{ r: 8 }} strokeWidth={3} dot={false}  />
        <Line yAxisId="left" type="monotone" dataKey="MinGateEntryTime" stroke="#59E6F6" activeDot={{ r: 8 }} strokeWidth={3} dot={false}  />
      </LineChart>
    </ResponsiveContainer>
</div>
<div className="vendor_cycle_time_dashboard_body_row">
  <div className="row_odsboard_body">
  <p className="time_onboarding_body">Goods Receipt Note Turnaround Time</p>
  <MoreVertIcon />
  </div>
  <ResponsiveContainer width="100%" height={300}>
    <BarChart className="dashboard_barchart" data={goodreceiptsdata}>
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="name" />
        <YAxis />
        <Tooltip />
        <Legend />
        <Bar dataKey="AverageGRNTAT" stackId="a" fill="#816FEA" />
        <Bar dataKey="MinGRNTAT" stackId="a" fill="#75DD66" />
        <Bar dataKey="MaxGRNTAT" stackId="a" fill="#0797AE" />
    </BarChart>
</ResponsiveContainer>
</div>
  </div>
        <div className="table_row_dashboard_body_main2_table">
          <div className="admin_dashboard_row_participation_here">
            <h4 className="text_vendors_dashboard_inpie">All P2P Transactional</h4>
            <div className="admin_dashboard_row_right_table">
              
              <button className="btn_bpdt_view_row_bidding_dash" onClick={() => navigateUrl(`/admin/buyer-purchaseOrder`)}>
                View all P2P Transactional
              </button>
            </div>
          </div>
          <div className="listing_main_row_dashboard_bpdt_block">
            <TableListingWithoutDnD
                    column={initialColumns}
                    listingArrName="purchaseOrders"
                    filterKeyName={""}
                    componentName="PO_List"
                    promiseRequest={purchaseOrderServices.getPurchaseOrderListing}
                    promiseUrlType="LIST"
                    additionalData={{
                      isMaster: false,
                      type: "PO_List",
                      isTrackOrder: false,
                      isFilter: false,
                      isSearch: false,
                      isSort: false,
                      isPagePerSize: false,
                      isPagination: false,
                      isDragable: false,
                    }}
                />
          </div>
          
          
        </div>
      </div>

      <AlertComponent
            alertComponent={alertComponent}
          handleClose={handleCloseAlert}
        />

        <Backdrop
          sx={{
            color: "#fff",
            zIndex: (theme) => 999999,
          }}
          open={isLoading}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
    </div>
  );
}

export default TransactionalP2PDashboardTab;
